<ngx-spinner bdColor="rgba(158,158,158,0.3)" size="medium" color="#2a295c" type="ball-spin" [fullScreen]="true">
</ngx-spinner>
<router-outlet></router-outlet>
